import { elementsOverlap, isMobile } from '@/functions';

export default () => {
  $(document).ready(function ($) {
    stickyAd();
    $(window).scroll(function () {
      stickyAd();
    });
  });

  function stickyAd() {
    if ($(".advertising-wrapper .fixedadmobile ").length === 0) {
      let scroll = $(window).scrollTop();

      if (scroll > 150) {
        $(".fixedadmobile").addClass('adisshow');
      } else {
        $(".fixedadmobile").removeClass('adisshow');
      }
    }
  }

  // Sticky Bottom Ad
  const stickyBottomAdCloseListener = (e) => {
    const el = e.target;
    if (el.tagName === 'DIV' && el.classList.contains('trf-ad-bottom-sticky-closer')) {
      ['resize', 'scroll'].forEach((evt) => {
        document.removeEventListener(evt, stickyBottomAdListener, true);
      });
      document.removeEventListener('click', stickyBottomAdCloseListener, true);
    }
  };
  document.addEventListener('click', stickyBottomAdCloseListener, true);

  const stickyBottomAdListener = () => {
    const newsSponsoredContent = document.getElementById('sponsored-content-wrapper');
    const stickyAd = document.querySelectorAll('.sticky-container-traffective-ad-Mobile_Sticky')[1];
    if (!newsSponsoredContent || !stickyAd) {
      return;
    }
    if (elementsOverlap(newsSponsoredContent, stickyAd)) {
      stickyAd.style.visibility = 'hidden';
    } else {
      stickyAd.style.visibility = 'visible';
    }
  };

  function logChangesSticky(records, observer) {
    for (const record of records) {
      const style = window.getComputedStyle(record.target);
      if (style.display === 'none') {
        ['resize', 'scroll'].forEach((evt) => {
          document.addEventListener(evt, stickyBottomAdListener, true);
        });
        observer.disconnect();
        break;
      }
    }
  }

  function logChangesBody(records) {
    for (const record of records) {
      for (const addedNode of record.addedNodes) {
        if (Array.from(addedNode.classList).includes('sticky-container-traffective-ad-Mobile_Sticky')) {
          new MutationObserver(logChangesSticky).observe(addedNode, { attributes: true });
        }
      }
    }
  }

  const newsSponsoredContent = document.getElementById('sponsored-content-wrapper');
  if (isMobile && newsSponsoredContent) {
    new MutationObserver(logChangesBody).observe(document.querySelector('body'), { childList: true });
  }
};
